<script>
import CheckMark from "../../../../core/Checkmark.vue";
import {money} from "../../../../../core/forms/money";

export default {
    name: "PayoutConfirmation",
    components: {CheckMark},
    mixins: [money],
    props:['wallet'],
    mounted() {
        setTimeout(() => {
            this.$router.push(`/business/wallet/${this.$route.params.id}/payouts`);
        }, 3000);
    }
}
</script>

<template>
    <div class="p-4">
        <h3 class="text-5 text-center mt-5 mb-3">Payout Request Confirmation</h3>
        <check-mark class="p-6"></check-mark>
        <p class="text-center text-4 mb-5">Your payout request was successful we have debited your wallet</p>
    </div>
</template>

<style scoped>

</style>
